export default function(map) {
  var values = [];
  for (var key in map) values.push(map[key]);
  return values;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-collection/src/values.js
// module id = 736
// module chunks = 0